<template>
  <div>
    <ListLayout
      ref="listTable"
      :title="`${announcementModule.announcementPlural}`"
      :tableData="announcementList"
      :tableHeader="tableHeaders"
      :total="totalItems"
      :context="context"
      @getList="getAnnouncementList"
    >
      <template #extraSpace>
        <div class="d-flex justify-center">
          <v-chip-group v-model="selectedFilter" @change="getAnnouncementList">
            <v-chip filter outlined value="active_announcement">
              Active
            </v-chip>
            <v-chip filter outlined value="archived_announcement">
              Archived
            </v-chip>
            <v-chip filter outlined value="schedule_announcement">
              Scheduled
            </v-chip>
          </v-chip-group>
        </div>
      </template>
      <template #listAction>
        <PrimaryButton
          id="announcementAdd"
          @click="$router.push({ name: 'add-announcement' })"
          :name="`Add ${announcementModule.announcement}`"
          icon="mdi-plus"
          iconSize="x-large"
        >
        </PrimaryButton>
      </template>
      <template #rightFilterSlot>
        <div class="w-100 d-flex align-center justify-end">
          <RefreshListButton
            id="announcementRefreshList"
            :isIcon="false"
            @click="$refs.listTable.searchTriggered()"
          />
        </div>
      </template>
      <template #dialogs>
        <AnnouncementDetailsDialog
          v-model="showAnnouncementDialog"
          :id="selectedID"
        />
      </template>
    </ListLayout>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import { bus } from "@/main.js";
import ListLayout from "@/components/LayoutComponents/ListLayout.vue";
import { announcementModule } from "@/utils/moduleMapping";
import RefreshListButton from "@/components/BaseComponents/RefreshListButton.vue";
import AnnouncementButton from "@/components/Button/AnnouncementButton.vue";
import AnnouncementDetailsDialog from "@/components/ModuleBasedComponents/Announcement/AnnouncementDetailsDialog.vue";

export default {
  components: {
    AnnouncementButton,
    ListLayout,
    RefreshListButton,
    AnnouncementDetailsDialog,
  },
  data() {
    return {
      announcementModule,
      totalItems: 0,
      filters: {},
      announcementList: [],
      headerSelected: [
        {
          headerName: "Title",
          field: "title",
          sortable: true,
          pinned: "left",
        },
        {
          headerName: "Start Date",
          field: "start_date",
          sortable: true,
        },
        {
          headerName: "Start Time",
          field: "start_time",
          sortable: true,
        },
        {
          headerName: "End Date",
          field: "end_date",
          sortable: true,
        },
        {
          headerName: "End Time",
          field: "end_time",
          sortable: true,
        },
        {
          headerName: "Notify via Email",
          field: "verify_group_via_email",
          sortable: true,
        },
        {
          headerName: "Visibility",
          field: "visibility",
          sortable: true,
        },
        {
          headerName: "Created By",
          field: "created_by",
          sortable: true,
        },
      ],

      selectedID: null,
      showAnnouncementDialog: false,

      selectedFilter: null,
    };
  },
  computed: {
    tableHeaders() {
      return [
        ...this.headerSelected,
        {
          headerName: "Actions",
          field: "actions",
          pinned: "right",
          minWidth: 150,
          maxWidth: 200,
          sortable: false,
          width: 120,
          cellRenderer: "AnnouncementButton",
        },
      ];
    },
    context() {
      return { childComponent: this };
    },
  },
  methods: {
    getAnnouncementList(params = {}) {
      bus.$emit("showLoader", true);
      params = {
        ...params,
        ...this.filters,
      };
      if ("ordering" in params && params.ordering.length > 0) {
        params = { ...params, ordering: params.ordering.join(",") };
      }
      if (this.selectedFilter) {
        params[this.selectedFilter] = true;
      }
      this.$api.announcement
        .getAnnouncementList(params)
        .then((res) => {
          this.announcementList = res.data;
          this.totalItems = res.count;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
    viewAnnouncement(id) {
      this.selectedID = id;
      this.showAnnouncementDialog = true;
    },
    deleteAnnouncement(id) {
      this.$api.announcement
        .deleteAnnouncementObject(id)
        .then(() => {
          this.$refs.listTable.searchTriggered();
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
  },
};
</script>
